import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AdministrationModel } from '../../../../models/administration.model'
import { BankService } from '../../../../services/bank/bank.service'
import { Subscription } from 'rxjs'
import { BankModel } from '../../../../models/bank.model'
import { BankaccountModel } from '../../../../models/bankaccount.model'
import { BankaccountsService } from '../../../../services/bankaccounts.service'

@Component({
  selector: 'app-administration-bankaccount-dialog',
  templateUrl: './administration-bankaccount-dialog.component.html',
  styleUrls: ['./administration-bankaccount-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdministrationBankaccountDialogComponent implements OnInit {
  dialogTitle: string
  form: FormGroup
  administration: AdministrationModel
  onBanksChange: Subscription
  banks: BankModel[]
  bankAccount: BankaccountModel
  countDeleteClicks = 0
  deleteClicks = 3
  isLoading = false

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AdministrationBankaccountDialogComponent>,
    private _bankService: BankService,
    private _bankAccountsService: BankaccountsService,
  ) {
    this.administration = data.administration
    this.bankAccount = data.bankAccount

    if (this.bankAccount === undefined) {
      this.dialogTitle = 'NEW_BANK_ACCOUNT'
      this.form = this.createBankAccountForm()
    } else {
      this.dialogTitle = 'EDIT_BANK_ACCOUNT'
      this.form = this.updateBankAccountForm()
    }
  }

  ngOnInit() {
    this.onBanksChange = this._bankService.onBanksChanged
      .filter(response => !!response)
      .subscribe((bankAccounts: BankModel[]) => {
        this.banks = bankAccounts
      })
  }

  createBankAccountForm() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      iban: ['', Validators.required],
      bank_id: ['', Validators.required],
      type: ['', Validators.required],
    })
  }

  updateBankAccountForm() {
    return this.formBuilder.group({
      name: [{ value: this.bankAccount.name, disabled: false }, Validators.required],
      iban: [{ value: this.bankAccount.iban, disabled: true }],
      bank_id: [{ value: this.bankAccount.bank, disabled: true }],
      type: [{ value: this.bankAccount.type, disabled: true }],
    })
  }

  /**
   * Deletes a bankaccount when button is clicked 3 times.
   */
  deleteBankAccount() {
    this.countDeleteClicks++

    if (this.countDeleteClicks < this.deleteClicks || !this.bankAccount || !this.administration) {
      return
    }

    this.isLoading = true

    this._bankAccountsService.delete(this.bankAccount.id, this.administration.id).subscribe(
      () => {
        this.onDeleteReady()
      },
      (err: any) => {
        console.error(err)
        this.onDeleteReady()
      },
    )
  }

  /**
   * Handles resetting the component
   */
  onDeleteReady() {
    this.countDeleteClicks = 0
    this.isLoading = false
    this.dialogRef.close()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-bankaccount-dialog/administration-bankaccount-dialog.component.ts